import NewProviderContract from './NewProviderContract';

export default NewProviderContract;
